import React from "react";
import styled from "@emotion/styled";

import { Text } from "@components/core/Text";
import { Modal } from "src/design-system/components/Modal/Modal";

import { fontP1Regular, fontP4Regular } from "src/design-system/styles/fonts";
import BackArrow from "@components/refactored-survey/images/back-arrow.svg";

const ModalWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const BackButton = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const BackArrowIcon = styled.img`
  width: 18px;
  height: 16px;
`;

const ContentArea = styled.div`
  padding-top: 36px;
`;

const ModalContent = styled.div`
  ${fontP4Regular}
  line-height: 28px;
  padding: 16px 0;
  white-space: pre-line;
`;

const Title = styled.h2`
  ${fontP1Regular}
  margin: 0 0 16px;
  text-align: left;
  text-transform: uppercase;
`;

type MedicareAttestationModalProps = {
  onClose: () => void;
};

export function MedicareAttestationModal({
  onClose,
}: MedicareAttestationModalProps) {
  return (
    <Modal onClose={onClose}>
      <ModalWrapper>
        <BackButton
          type="button"
          onClick={onClose}
          aria-label="Back"
          data-cy="medicare-attestation-modal-back"
        >
          <BackArrowIcon src={BackArrow} alt="" />
        </BackButton>
        <ContentArea>
          <Title>
            <Text i18nKey="payment:terms:medicareAttestation:modalTitle" />
          </Title>
          <ModalContent>
            <Text i18nKey="payment:terms:medicareAttestation:modalContent" />
          </ModalContent>
        </ContentArea>
      </ModalWrapper>
    </Modal>
  );
}
